import { createAsyncThunk } from '@reduxjs/toolkit';

import { MyInvestmentsService } from 'api';
import { DownloadAssigmentAgreementProps } from 'models/api';

import { downloadDocuments } from 'utils';

interface DownloadAssigmentAgreementData extends DownloadAssigmentAgreementProps {
	fileName: string;
}

export const downloadAssigmentAgreement = createAsyncThunk(
	'myInvestments/downloadAssigmentAgreement',
	(data: DownloadAssigmentAgreementData) =>
		downloadDocuments(data, data.fileName, MyInvestmentsService.downloadAssigmentAgreement),
);
